import 'babel-polyfill'
import 'whatwg-fetch'
import 'custom-event-polyfill'

import Vue from 'vue'
import App from '@/App.vue'
import { router } from '@/router'
import '@/style/style.sass'
import store from '@/store'

Vue.config.productionTip = false

// Create custom store
Vue.prototype.$store = store.global

new Vue({
    data:
    {
        // Dynamise custom store
        store: store.global
    },
    router,
    render: h => h(App)
}).$mount('#app')
